import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bindActionCreators } from "@reduxjs/toolkit";
import { formatMessage } from "i18n/CurrentLocale";
import { ModalEnum } from "myParkdUtils/enums";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import * as modalWindowActions from 'root/modal/modalWindowActions';
import { ReduxState, Vehicle } from "types";


export const EditWorkingHoursButton = (props: Props) => (

    <button
        className={props.vehicle.workingWeek ? "btn-small-blue" : "btn-small-green"}
        onClick={() => props.updateModal(ModalEnum.EDIT_WORKING_HOURS_LICENSEPLATE, props.vehicle)}
    >

        {((props.hasCompanyWorkingHours && props.vehicle?.workingWeek) || (!props.hasCompanyWorkingHours && props.vehicle.workingWeek)) && (
            <>
                <FontAwesomeIcon icon={faEdit} className='fa-icon' />
                <FormattedMessage id='LP_WH_BTN_CUSTOM' />
            </>
        )}

        {props.hasCompanyWorkingHours && !props.vehicle.workingWeek && (
            <>
                <FontAwesomeIcon icon={faEdit} className='fa-icon' />
                <FormattedMessage id='LP_WH_BTN_DEFAULT' />
            </>
        )}

        {!props.hasCompanyWorkingHours && !props.vehicle.workingWeek && (
            <>
                <FontAwesomeIcon icon={faPlus} className='fa-icon' />
                <FormattedMessage id='LP_WH_BTN_ADD' />
            </>
        )}
    </button>
)

type OwnProps = { vehicle: Vehicle }
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & StateProps & OwnProps;

function mapStateToProps(state: ReduxState) {
    return {
        hasCompanyWorkingHours: !!state.companyDetails?.companyDetails?.workingHoursStart
    }
}

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators({
        updateModal: modalWindowActions.updateModalWindow
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditWorkingHoursButton);
